<template>
  <g-popup title="상품 담당자" width="600" :background-click="false">
    <template #body>
      <div class="-font-size-12">
        <g-search-bar
          style="width: calc(100% - 30px);"
          no-border
          full
          placeholder="Search anything"
          v-model="searchText" />

        <ag-grid-vue id="company-popup-ag-grid-vue"
                     style="height: 400px;"
                     class="ag-theme-balham"
                     row-height="30"
                     header-height="30"
                     :defaultColDef="defaultColDef"
                     :columnDefs="columnDefs"
                     :gridOptions="gridOptions"
                     :rowData="companyList"
                     :overlayLoadingTemplate="overlayLoadingTemplate"
                     :loadingOverlayComponent="loadingOverlayComponent"
                     :loadingOverlayComponentParams="loadingOverlayComponentParams"
                     :overlayNoRowsTemplate="overlayNoRowsTemplate"
                     :noRowsOverlayComponent="noRowsOverlayComponent"
                     :noRowsOverlayComponentParams="noRowsOverlayComponentParams"
                     :frameworkComponents="frameworkComponents"
                     :modules="modules"
                     :paginationPageSize="paging.size"
                     :pagination="true"
                     :suppressPaginationPanel="true"
                     :suppressScrollOnNewData="true"
                     @pagination-changed="paginationChanged"
                     @grid-ready="onGridReady"
                     @row-data-changed="onRowDataChanged">
        </ag-grid-vue>

        <g-pagenation
          id="product-productlist-g-pagenation"
          class="-py-6"
          :page-no="paging.pageNo"
          :page-size-list="pageSizeList"
          :page-size="paging.size"
          :total-count="paging.totalCount"
          @change-page-no="onChangePageNo"
          @change-page-size="onChangePageSize"/>

      </div>
    </template>
    <template #footer>
      <g-button @click="onClickCancel" variant="secondary"><span>{{$t('common.cancel')}}</span></g-button><!--
      --><g-button @click="onSubmit" :disabled="!isSelected"><span>{{$t('common.save')}}</span></g-button>
    </template>
  </g-popup>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { AgGridVue } from 'ag-grid-vue';
import AgGridMixin from '@/pages/mixin/AgGrid.mixin'
import RadioCell from '@/pages/components/ag-grid/RadioCell'
import {DEFAULT_OPTION_PER_PAGE, DEFAULT_PAGE_SIZE} from "@/constants/constants";
export default {
  name: 'company-popup',
  components: {
    AgGridVue
  },
  mixins: [AgGridMixin()],
  props: {
    instKey: {
      type: String,
      default: null
    },
    onSend: {
      type: Function,
      defalut: () => () => {}
    },
    onCancel: {
      type: Function,
      defalut: () => () => {}
    },
    selectedManagerId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      searchText: '',
      selectedValue: {},
      columnDefs: {},
      defaultColDef: {},
      gridOptions: null,
      size: 5,
      pageSizeList: DEFAULT_OPTION_PER_PAGE,
      paging: {
        pageNo: 1,
        size : DEFAULT_PAGE_SIZE,
        totalCount : 0
      },
    }
  },
  computed: {
    ...mapGetters('customer', ['companyList']),
    isSelected () {
      return Object.keys(this.selectedValue).length !== 0
    },
    companyListExceptSelectManager () {
      return this.companyList.filter(item => item.userEmail !== this.selectedManagerId)
    }
  },
  methods: {
    ...mapActions('customer', ['getCompanyList']),
    onGridReady(params) {
      this.setGridParams(params);
      this.getCompanyList()
      this.setGridParams(params)
      this.fitGrid()
    },
    rowClicked (e) {},
    onSubmit () {
      if (this.onSend) {
        this.onSend(this.selectedValue)
      }
      this.$popupManager.close(this.instKey)
    },
    onClickCancel () {
      if (this.onCancel instanceof Function) {
        this.onCancel()
      }
      this.$popupManager.close(this.instKey)
    },
    onRowDataChanged () {
      this.fitGrid()
    },
    onChangePageNo (pageNo) {
      this.paging.pageNo = pageNo;
      this.gridApi.paginationGoToPage(pageNo - 1);
    },
    onChangePageSize (pageSize) {
      this.paging.size = pageSize;
      this.paging.pageNo = 1;
      this.gridApi.paginationSetPageSize(this.paging.size);
      this.gridApi.paginationGoToPage(this.paging.pageNo - 1);
      this.fitGrid();
    },
    paginationChanged (e) { // totalcount 업데이트
      this.paging.totalCount = e.api.rowModel.rowsToDisplay.length
    },
    setColumn () {
      this.columnDefs = [
        {
          headerName: '선택',
          field: "empNo",
          width: 100,
          cellStyle : {"cursor":"pointer"},
          cellRenderer: RadioCell,
          onChecked: (row) => {
            this.selectedValue = row
          }
        },
        {
          headerName: '담당자명',
          field: "userName",
          width: 160,
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"}
        },
        {
          headerName: '담당자 이메일',
          field: "userEmail",
          width: 250,
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"}
        },
        {
          headerName: '사업부명',
          field: "deptName",
          width: 150,
          unSortIcon: true,
          cellStyle : {"cursor":"pointer"}
        },
      ];
      this.fitGrid()
    }
  },
  watch: {
    searchText () {
      this.gridOptions.api.setQuickFilter(this.searchText)
    },
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/components/CompanyPopup.vue